export default __webpack_public_path__ + "static/media/education_resources.5e3b296e.webp";